/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  alarmReadAll,
  alarmOperatorReadAll,
  alarmOperatorNewReadAll,
  alarmOperatorPlannedReadAll,
  alarmOperatorCurrentReadAll,
  alarmOperatorClosedReadAll,
  alarmResponderReadAll,
  alarmUpdate,
  alarmRead,
  alarmDelete,
  additionalServiceRead,
} from '../thunks/alarm';


const initialState = {
  alarms: {},
  alarmIds: [],
  operatorAlarms: {},
  operatorAlarmIds: [],
  operatorNewAlarms: {},
  operatorNewAlarmIds: [],
  operatorPlannedAlarms: {},
  operatorPlannedAlarmIds: [],
  operatorCurrentAlarms: {},
  operatorCurrentAlarmIds: [],
  operatorClosedAlarms: {},
  operatorClosedAlarmIds: [],
  responderAlarms: {},
  responderAlarmIds: [],

  additionalServices: [
    // array of: [{"id":"6555f304-a118-49d5-adda-1c13d91d984d","terms_of_service":{"id":"7df5e8f1-87cf-41a8-98e4-c8f2cac85fc5","accepted":false,"date_accepted":null},"price":10000,"currency":"HRK","home":"5a17ddaa-d321-485b-afe7-cb187a56a48a","service_type_id":"c326d95c-09b5-4b6c-9afa-60afbc840328","delivery_process":"additional","charge_free":false,"about":"orem ipsum dolor sit amet, consectetur adipiscing elit. Cras egestas dolor non nunc dictum lobortis. Nunc maximus quis felis ac condimentum. Maecenas suscipit, elit consequat viverra mollis, eros arcu euismod libero, in dignissim justo ex at quam. In venenatis euismod mi non vehicula. Integer lorem lorem, aliquam luctus consectetur sit amet, sollicitudin nec nibh. Pellentesque at nulla ornare, vulputate odio porttitor, sodales enim. Mauris maximus sem maximus mauris dictum, et sagittis eros finibus. Sed ac ornare tellus. Integer consectetur nunc cursus sem placerat iaculis. Vivamus arcu massa, tempor eget orci sed, pharetra auctor erat. Nam quis efficitur nunc, eu auctor ex. Nulla tincidunt cursus ipsum nec volutpat.\r\n\r\nPellentesque venenatis nisl non nisi gravida, pellentesque ultrices massa sodales. Phasellus blandit neque elit, eu tincidunt purus convallis a. Integer augue ex, pulvinar id ex scelerisque, maximus ultrices elit. Quisque non neque ut dolor faucibus varius. Etiam accumsan urna quis mauris tincidunt faucibus. Sed molestie tellus quis tellus finibus, vitae consequat libero commodo. Praesent mattis pellentesque fringilla. In hac habitasse platea dictumst. Sed vulputate sodales sem, sit amet placerat metus sollicitudin sit amet. Curabitur ultricies lectus mauris, congue mattis justo ultrices mollis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce id elit eu massa viverra dapibus mattis eget nibh. Curabitur at tempor ante.\r\n\r\norem ipsum dolor sit amet, consectetur adipiscing elit. Cras egestas dolor non nunc dictum lobortis. Nunc maximus quis felis ac condimentum. Maecenas suscipit, elit consequat viverra mollis, eros arcu euismod libero, in dignissim justo ex at quam. In venenatis euismod mi non vehicula. Integer lorem lorem, aliquam luctus consectetur sit amet, sollicitudin nec nibh. Pellentesque at nulla ornare, vulputate odio porttitor, sodales enim. Mauris maximus sem maximus mauris dictum, et sagittis eros finibus. Sed ac ornare tellus. Integer consectetur nunc cursus sem placerat iaculis. Vivamus arcu massa, tempor eget orci sed, pharetra auctor erat. Nam quis efficitur nunc, eu auctor ex. Nulla tincidunt cursus ipsum nec volutpat.\r\n\r\nPellentesque venenatis nisl non nisi gravida, pellentesque ultrices massa sodales. Phasellus blandit neque elit, eu tincidunt purus convallis a. Integer augue ex, pulvinar id ex scelerisque, maximus ultrices elit. Quisque non neque ut dolor faucibus varius. Etiam accumsan urna quis mauris tincidunt faucibus. Sed molestie tellus quis tellus finibus, vitae consequat libero commodo. Praesent mattis pellentesque fringilla. In hac habitasse platea dictumst. Sed vulputate sodales sem, sit amet placerat metus sollicitudin sit amet. Curabitur ultricies lectus mauris, congue mattis justo ultrices mollis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce id elit eu massa viverra dapibus mattis eget nibh. Curabitur at tempor ante.","name":"Guarding / hour","params":{},"discount":{},"measurement_unit":"man/hour","company":"6833c47d-59d1-49c9-9b2d-6955fcb6f06a","additional_services":[]}]

  ]
};

const alarm = createSlice({
  name: 'alarm',
  initialState,
  reducers: {
    setUser(state, action) {
      state.id = action.payload;
    },
    setPermissions(state, action) {
      state.alarms = action.payload;
    },
  },

  extraReducers: {

    [alarmReadAll.fulfilled]: (state, action) => {
      const actionPermissions = Array.isArray(action?.payload) ? action.payload : [];
      const statePermissions = {};
      const statePermissionIds = [];
      actionPermissions.forEach((actionPermission) => {
        statePermissions[actionPermission.id] = actionPermission;
        statePermissionIds.push(actionPermission.id);
      });
      state.alarms = statePermissions;
      state.alarmIds = statePermissionIds;
    },
    [alarmReadAll.rejected]: (state) => {
      state.alarms = [];
    },
    [alarmOperatorReadAll.fulfilled]: (state, action) => {
      const actionPermissions = Array.isArray(action?.payload) ? action.payload : [];
      const statePermissions = {};
      const statePermissionIds = [];
      actionPermissions.forEach((actionPermission) => {
        statePermissions[actionPermission.id] = actionPermission;
        statePermissionIds.push(actionPermission.id);
      });
      state.operatorAlarms = statePermissions;
      state.operatorAlarmIds = statePermissionIds;
    },
    [alarmOperatorReadAll.rejected]: (state) => {
      state.operatorAlarms = [];
      state.operatorAlarmIds = [];
    },
    [alarmOperatorNewReadAll.fulfilled]: (state, action) => {
      const actionPayload = Array.isArray(action?.payload) ? action.payload : [];
      const entities = {};
      const ids = [];
      actionPayload.forEach((payload) => {
        entities[payload.id] = payload;
        ids.push(payload.id);
      });
      state.operatorNewAlarms = entities;
      state.operatorNewAlarmIds = ids;
    },
    [alarmOperatorNewReadAll.rejected]: (state) => {
      state.operatorNewAlarms = [];
      state.operatorNewAlarmIds = [];
    },
    [alarmOperatorPlannedReadAll.fulfilled]: (state, action) => {
      const actionPayload = Array.isArray(action?.payload) ? action.payload : [];
      const entities = {};
      const ids = [];
      actionPayload.forEach((payload) => {
        entities[payload.id] = payload;
        ids.push(payload.id);
      });
      state.operatorPlannedAlarms = entities;
      state.operatorPlannedAlarmIds = ids;
    },
    [alarmOperatorPlannedReadAll.rejected]: (state) => {
      state.operatorPlannedAlarms = [];
      state.operatorPlannedAlarmIds = [];
    },
    [alarmOperatorCurrentReadAll.fulfilled]: (state, action) => {
      const actionPayload = Array.isArray(action?.payload) ? action.payload : [];
      const entities = {};
      const ids = [];
      actionPayload.forEach((payload) => {
        entities[payload.id] = payload;
        ids.push(payload.id);
      });
      state.operatorCurrentAlarms = entities;
      state.operatorCurrentAlarmIds = ids;
    },
    [alarmOperatorCurrentReadAll.rejected]: (state) => {
      state.operatorCurrentAlarms = [];
      state.operatorCurrentAlarmIds = [];
    },
    [alarmOperatorClosedReadAll.fulfilled]: (state, action) => {
      const actionPayload = Array.isArray(action?.payload) ? action.payload : [];
      const entities = {};
      const ids = [];
      actionPayload.forEach((payload) => {
        entities[payload.id] = payload;
        ids.push(payload.id);
      });
      state.operatorClosedAlarms = entities;
      state.operatorClosedAlarmIds = ids;
    },
    [alarmOperatorClosedReadAll.rejected]: (state) => {
      state.operatorClosedAlarms = [];
      state.operatorClosedAlarmIds = [];
    },
    [alarmResponderReadAll.fulfilled]: (state, action) => {
      const actionPermissions = Array.isArray(action?.payload) ? action.payload : [];
      const statePermissions = {};
      const statePermissionIds = [];
      actionPermissions.forEach((actionPermission) => {
        statePermissions[actionPermission.id] = actionPermission;
        statePermissionIds.push(actionPermission.id);
      });
      state.responderAlarms = statePermissions;
      state.responderAlarmIds = statePermissionIds;
    },
    [alarmResponderReadAll.rejected]: (state) => {
      state.responderAlarms = [];
      state.responderAlarmIds = [];
    },
    [alarmUpdate.fulfilled]: (state, action) => {
      if (!state.alarmIds.includes(action.payload.id)) {
        state.alarmIds.push(action.payload.id);
      }
      state.alarms[action.payload.id] = action.payload;
    },
    [alarmUpdate.rejected]: (state, action) => {
      console.log(action);
    },
    [alarmRead.fulfilled]: (state, action) => {
      if (!state.alarmIds.includes(action.payload.id)) {
        state.alarmIds.push(action.payload.id);
      }
      state.alarms[action.payload.id] = action.payload;
    },
    [alarmRead.rejected]: (state, action) => {
      const id = action?.meta?.arg?.id || 0;
      if (id) {
        delete state.alarms[id];
        state.alarmIds = state.alarmIds.filter((pId) => pId !== id);
      }
    },
    [alarmDelete.fulfilled]: (state, action) => {
      const id = action?.meta?.arg?.id || 0;
      if (id) {
        delete state.alarms[id];
        state.alarmIds = state.alarmIds.filter((pId) => pId !== id);
      }
    },
    [alarmDelete.rejected]: (state, action) => {
      console.log(action);
    },

    [additionalServiceRead.fulfilled]: (state, action) => {

      action.payload.forEach(service => {
        const existingservice = state.additionalServices.find(s => s.id === service.id);
        state.additionalServices = [
          ...state.additionalServices.filter(s => s.id !== service.id),
          {
            ...service,
            parentServices: [...new Set([
              ...(existingservice?.parentServices || []),
              action?.meta?.arg?.id
            ])]
          }
        ];
      });
    },
    [additionalServiceRead.rejected]: (state, action) => {
      const id = action?.meta?.arg?.id || 0;
      if (id) {
        delete state.alarms[id];
        state.alarmIds = state.alarmIds.filter((pId) => pId !== id);
      }
    },


  },
});

export const {
  setUser,
  setPermissions,
} = alarm.actions;

export default alarm;
